import request from '@/utils/request'

let CouponApi = {

  /*优惠券列表*/
  couponList(data, errorback) {
    return request._post('/shop/plus.coupon.coupon/index', data, errorback);
  },
   hxList(data, errorback) {
    return request._post('/shop/plus.coupon.coupon/hxindex', data, errorback);
  },
  toggleStatus(data, errorback) {
    return request._post('/shop/plus.coupon.coupon/toggleStatus', data, errorback);
  },
  /*添加优惠券*/
  addCoupon(data, errorback) {
    return request._post('/shop/plus.coupon.coupon/add', data, errorback);
  },
  /*获取优惠券信息*/
  couponDetail(data, errorback) {
    return request._post('/shop/plus.coupon.coupon/couponDetail', data, errorback);
  },
  /*修改优惠券*/
  editCoupon(data, errorback) {
    return request._post('/shop/plus.coupon.coupon/edit', data, errorback);
  },
  /*修改优惠券*/
  genCard(data, errorback) {
    return request._post('/shop/plus.coupon.coupon/genCard', data, errorback);
  },
  /*删除优惠券*/
  deleteCoupon(data, errorback) {
    return request._post('/shop/plus.coupon.coupon/delete', data, errorback);
  },
  /*优惠券领取记录*/
  receiveList(data, errorback) {
    return request._post('/shop/plus.coupon.coupon/receive', data, errorback);
  },
  /*提货卡使用记录*/
  getPickUpCouponUsedLog(data, errorback) {
    return request._post('/shop/plus.coupon.coupon/getPickUpCouponUsedLog', data, errorback);
  },
  /*去发送优惠券*/
  toSendCoupon(data, errorback) {
    return request._get('/shop/plus.coupon.coupon/SendCoupon', data, errorback);
  },
  /*发送优惠券*/
  SendCoupon(data, errorback) {
    return request._post('/shop/plus.coupon.coupon/SendCoupon', data, errorback);
  },
  /*发送优惠券*/
  getCouponSet(data, errorback) {
    return request._get('/shop/plus.coupon.coupon/couponSet', data, errorback);
  },
  /*发送优惠券*/
  setCouponSet(data, errorback) {
    return request._post('/shop/plus.coupon.coupon/couponSet', data, errorback);
  },
}

export default CouponApi;



// WEBPACK FOOTER //
// ./src/api/coupon.js